// extracted by mini-css-extract-plugin
export default {"passwordWeak":"PasswordStrengthRating_passwordWeak__G7njj","passwordStrong":"PasswordStrengthRating_passwordStrong__Ry2uv"};